<template>
  <BCard class="border rounded p-0 col-12 col-lg-3">
    <div class="d-flex flex-column gap-2">
      <span>{{ title }}</span>
      <div class="d-flex align-items-center gap-3">
        <span class="text-black text-[24px] font-semibold">{{ IDR(data.total || 0) }}</span>
        <span
          v-if="data.percentage !== 0"
          :class="badgeClass(data.percentage)"
          class="px-[10px] py-[4px] rounded rounded-pill"
        >{{ Number.isInteger(Number(data.percentage)) ? Number(data.percentage) : Number(data.percentage).toFixed(2) }}%</span>
      </div>
      <span class="text-[#626262]">
        Last month revenue : <span class="text-black"> {{ IDR(data.last_month || 0) }}</span>
      </span>
    </div>
  </BCard>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  name: 'RevenueCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({
        total: 0,
        percentage: 0,
        last_month: 0,
      }),
    },
  },
  methods: {
    IDR,
    badgeClass(v) {
      return v > 0 ? 'increased-second' : 'decreased-second'
    },
  },
}
</script>

<style scoped>
.decreased-second {
  background-color: #FCBEBE;
  color: #E31A1A;
  width: fit-content;
}
.increased-second {
  background-color: #BEFCDE;
  color: #34A770;
  width: fit-content;
}
</style>
